import React from 'react';
import {useAppState} from "@nutastic/nutastic-react-app";

const Footer = () => {
    const { footerNavExplore = [], footerNavConnect = [], socialMedia = [] } = useAppState();
    const componentClass = 'footer';
    const copyrightYear = new Date().getFullYear();

    const renderedSocialLinks = socialMedia.map(({url, type},i) => {
        return <a href={url} target="_blank" className="socialLink" key={i}>{ type }</a>;
    });

    const renderNavLinks = navItems => navItems.map((n,i) => {
        const { href, title, new_window } = n;
        return <a key={i} href={href} target={ parseInt(new_window) ? "_blank" : "_self"}>{ title }</a>;
    });


    return <footer className={componentClass}>
        <div className="container">
            <div className={`${componentClass}__links`}>
                <div className="column">
                    <h5>Follow</h5>
                    { renderedSocialLinks }
                </div>
                <div className="column">
                    <h5>Explore</h5>
                    { renderNavLinks(footerNavExplore) }
                </div>
                <div className="column mr-0">
                    <h5>Connect</h5>
                    { renderNavLinks(footerNavConnect) }
                </div>
            </div>
            <div className={`${componentClass}__copyright`}>
                LaRonda James &copy; {copyrightYear}. All Rights Reserved.
            </div>
        </div>
    </footer>;
};

export default Footer;
